import { PawPrint } from "lucide-react";

const ITEMS = [
  "Franchise 500 #1 Rank",
  "Entrepreneur Top Franchise for Women",
  "$165B Pet Market",
  "300+ Locations",
  "90 Net Promoter Score",
  "Recurring Membership Revenue",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-[#0D3B3E] py-5 overflow-hidden" data-testid="accolades-marquee">
      <div className="animate-marquee flex whitespace-nowrap items-center gap-10 w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 text-[#FBF9F5]/80 font-display font-semibold text-sm uppercase tracking-[0.2em]">
            {item}
            <PawPrint className="w-4 h-4 text-[#FF6B4A]" />
          </span>
        ))}
      </div>
    </div>
  );
}
